<section class="spinner-screen__content">
  <span class="spinner-screen__spinner" aria-hidden="true"></span>
  <!-- <h1 class="spinner-screen__title">{{ title }}</h1>
  <p class="spinner-screen__message">{{ message }}</p> -->
</section>
